import { buildStyleFns } from '../buildStyleFns';
export const borderRadiusStyleFnConfigs = [
    {
        name: 'borderRadius',
        properties: ['borderRadius'],
        system: 'shape',
    },
    {
        name: 'borderTopLeftRadius',
        properties: ['borderTopLeftRadius'],
        system: 'shape',
    },
    {
        name: 'borderTopRightRadius',
        properties: ['borderTopRightRadius'],
        system: 'shape',
    },
    {
        name: 'borderBottomLeftRadius',
        properties: ['borderBottomLeftRadius'],
        system: 'shape',
    },
    {
        name: 'borderBottomRightRadius',
        properties: ['borderBottomRightRadius'],
        system: 'shape',
    },
];
export const borderRadiusFns = buildStyleFns(borderRadiusStyleFnConfigs);
